import { render, staticRenderFns } from "./TerminalBlocks.vue?vue&type=template&id=08f7d326&scoped=true"
import script from "./TerminalBlocks.vue?vue&type=script&lang=js"
export * from "./TerminalBlocks.vue?vue&type=script&lang=js"
import style0 from "./TerminalBlocks.vue?vue&type=style&index=0&id=08f7d326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7d326",
  null
  
)

export default component.exports